import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

//TODO: make final setup

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASE_URL,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
// };

const firebaseConfig = {
  apiKey: "AIzaSyAFIYgR4iG6BgevQVusYHp0qSUX2A4PXuA",
  authDomain: "manfol-3b2ab.firebaseapp.com",
  projectId: "manfol-3b2ab",
  storageBucket: "manfol-3b2ab.appspot.com",
  messagingSenderId: "304240149370",
  appId: "1:304240149370:web:0b00db3489dd04a4e70cc3",
  measurementId: "G-LNL5N0QP0P",
 };

// const firebaseConfigTest = {
//   apiKey: "AIzaSyBsW2fQGqgpR9xyIjTNA6sk1TYLF-USf78",
//   authDomain: "manfol-ab029.firebaseapp.com",
//   projectId: "manfol-ab029",
//   storageBucket: "manfol-ab029.appspot.com",
//   messagingSenderId: "364726979531",
//   appId: "1:364726979531:web:9da76cf43966e6fdae044e",
//   measurementId: "G-KH1XMSVVEL"
// };

const app = initializeApp(firebaseConfig);

export default getFirestore();